exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.filters{position:relative;display:flex;flex-direction:column;height:180px}.filters .filter-selector-label{font-family:Open Sans,sans-serif;font-size:10px;color:#8b8b8b;letter-spacing:1px;margin-top:20px;margin-bottom:4px;font-weight:300;font-style:italic}.filters .filter-selector-container{width:217px;height:30px;border:1px solid #b8b8b8;text-indent:12px}.filters .filter-selector-container .caret{position:absolute;width:9px;height:6px;right:11px;top:13px;z-index:9}.filters .filter-selector-container .selected-value{line-height:32px;font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#000}.filters .show-archived-checkbox{display:flex;height:24px;margin-top:20px}.filters .show-archived-checkbox .checkbox{margin-right:10px}.filters .show-archived-checkbox .caption{font-family:Open Sans,sans-serif;font-weight:400;font-size:12px;color:#000;line-height:24px}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/ProjectFilters/ProjectFilters.scss
// module id = 1604
// module chunks = 0